import { render, staticRenderFns } from "./fastLink.vue?vue&type=template&id=7cb220ea&scoped=true&"
import script from "./fastLink.vue?vue&type=script&lang=js&"
export * from "./fastLink.vue?vue&type=script&lang=js&"
import style0 from "./fastLink.vue?vue&type=style&index=0&id=7cb220ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cb220ea",
  null
  
)

export default component.exports